<template>
  <div>
    <div class="scroll">
      <div v-for="whistleblowercomment in whistleblowercommentlist" :key="whistleblowercomment.id">
        <div :class="messageClass(whistleblowercomment.user)">
          <div v-if="whistleblowercomment.user">{{ $tc("investigator") }}:</div>
          <div v-else>{{ $tc("whistleblower") }}:</div>
          <br />
          {{ whistleblowercomment.message }}
          <br />
          <span class="time-right">{{ timeParse(whistleblowercomment.time) }}</span>
        </div>
        <br />
      </div>
    </div>
    <strong>
      {{ $t("sendAMessage") }}
    </strong>
    <b-form-textarea
      id="message"
      v-model="message"
      placeholder
      rows="2"
      max-rows="10"
      ref="whistleblowerreport.how_info"
    ></b-form-textarea>
    <pw-button v-if="this.anonymous" @accepted="sendComment" icon="fa-paper-plane" className="dark">
      {{ $t("send") }}
    </pw-button>
    <pw-button v-else-if="!this.anonymous" @accepted="sendAdminComment" icon="fa-paper-plane" className="dark">
      {{ $t("send") }}
    </pw-button>
  </div>
</template>

<script>
import PwButton from "../../components/PwButton.vue";
import WhistleblowerComment from "@/models/WhistleblowerComment";
import WhistleblowerCommentService from "@/services/WhistleblowerCommentService";
import moment from "moment";

export default {
  components: { PwButton },
  data() {
    return {
      message: "",
      whistleblowercomment: new WhistleblowerComment({}),
      whistleblowercommentlist: [],
      getComentsInterval: "",
      getAdminCommentsInterval: ""
    };
  },
  computed: {},
  props: {
    password: {
      type: String,
      default: ""
    },
    report: {
      default: ""
    },
    anonymous: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    //computes what the class of a message should be, if user is null display one class, if user is present(means an investigator sent a message) display the message differently
    messageClass(user) {
      if (user == null) {
        return "message whistleblower";
      } else {
        return "message investigator";
      }
    },
    sendComment() {
      this.whistleblowercomment.message = this.message;
      this.message = "";
      WhistleblowerCommentService.createWhistleblowerComment(
        this.report.guid,
        this.password,
        this.whistleblowercomment
      ).then((whistleblowercomment) => {
        this.getComments();
      });
    },
    //get comments anonymously
    getComments() {
      WhistleblowerCommentService.getWhistleblowerComments(this.report.guid, this.password).then(
        (whistleblowercomment) => {
          this.whistleblowercommentlist = whistleblowercomment;
        }
      );
    },
    //get comments if admin
    getAdminComments() {
      WhistleblowerCommentService.getAdminWhistleblowerComments(this.report.guid).then((whistleblowercomment) => {
        this.whistleblowercommentlist = whistleblowercomment;
      });
    },
    sendAdminComment() {
      this.whistleblowercomment.message = this.message;
      this.whistleblowercomment.report = this.report.id;
      this.message = "";
      WhistleblowerCommentService.createAdminWhistleblowerComment(this.report.guid, this.whistleblowercomment).then(
        (whistleblowercomment) => {
          this.getAdminComments();
        }
      );
    },
    timeParse(time) {
      return moment(time).startOf("minute").fromNow();
    }
  },
  mounted() {
    if (this.anonymous == true) {
      this.whistleblowercomment.user = null;
      this.getComments();
      this.getComentsInterval = setInterval(() => {
        this.getComments();
      }, 5000);
    } else {
      this.whistleblowercomment.user = this.$user.id;
      this.getAdminComments();
      this.getAdminComentsInterval = setInterval(() => {
        this.getAdminComments();
      }, 5000);
    }
  },
  destroyed() {
    clearInterval(this.getComentsInterval);
    clearInterval(this.getAdminComentsInterval);
  }
};
</script>

<style lang="scss" scoped>
.message {
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
  width: 30%;
}

.whistleblower {
  text-align: left;
  color: rgb(0, 0, 0);
  background-color: #ddd;
  border: 2px solid #ccc;
  margin-left: auto;
  margin-right: 0;
}

.time-right {
  float: right;
  font-size: 10px;
}

.investigator {
  border-color: #ccc;
  background-color: #05728f;
  color: #ddd;
  text-align: left;
  margin-right: auto;
  margin-left: 0;
}

.message::after {
  content: "";
  clear: both;
  display: table;
}

.scroll {
  height: 600px;
  overflow-y: auto;
}
</style>
